import axios from 'axios';
import { buildQueryString } from '@/services/utils';

const instance = axios.create({
  baseURL: process.env.BASE_URL
});

export const handleGetWardrobe = async (wardrobeId) => {
  try {
    const response = await instance.get(`/wardrobes/${wardrobeId}`);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleGetWardrobeOutfits = async (wardrobeId) => {
  try {
    const response = await instance.get(`/wardrobes/${wardrobeId}/wardrobe_outfits`);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleGetWardrobeProducts = async (payload) => {
  let { wardrobeId, ...params } = { ...payload };
  const queryString = buildQueryString(params)

  try {
    const response = await instance.get(`/wardrobes/${wardrobeId}/products${queryString}`);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleCreateWardrobeOutfit = async (wardrobeId, payload) => {
  try {
    const response = await instance.post(`/wardrobes/${wardrobeId}/wardrobe_outfits`, payload);
    return response;
  } catch (error) {
    return error;
  }
};

export const handleAddProductRequest = async (payload) => {
  const params = {
    wardrobe: {
      url: payload['productUrl'],
      product_id: payload['productId'],
      similar: payload['similar'],
      group: payload['group']
    }
  }

  try {
    const response = await instance.post(`/wardrobes/${payload['wardrobeId']}/products`, params);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleUpdateProductRequest = async (payload) => {
  const params = {
    wardrobe: {
      similar: payload['similar']
    }
  }

  try {
    const response = await instance.put(`/wardrobes/${payload['wardrobeId']}/products/${payload['productId']}`, params);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleRemoveProductRequest = async (payload) => {
  try {
    const response = await instance.delete(`/wardrobes/${payload['wardrobeId']}/products/${payload['productId']}`);

    return response;
  } catch (error) {
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/store/api/wardrobe/index.js